import operators from "./operators";
/*
category: friendlyName of table
table: actual table name
fullTableName: incase if i need to send this when switching between modes to prepopulate the fields
column: actually name of column used for fields with no filters
friendlyName: used for fields and filters
translation: translates the filter into plain english
queryBuilderJSON: filter rules
distinctValueJSON: this will fire 
*/
const version = "1.0";
const globalLimit = 1000;
const db = "Document";
const patientTableName = "";
const dbType = "Document Search";

const data = {
  version,
  globalLimit,
  db,
  patientTableName,
  queryItems: [
    {
      category: "Diagnostic Procedure",
      table: "DIAGNOSTIC_PROCEDURE",
      fullTableName: "DIAGNOSTIC_PROCEDURE",
      friendlyName: "Diagnostic Procedure",
      key: "DIAGNOSTIC_PROCEDURE",
      column: "DIAGNOSTIC_PROCEDURE",
      operator: "=",
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "DIAGNOSTIC_PROCEDURE";
          },
          friendlyName: "Diagnostic Procedure",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType: "Document Search",
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "DIAGNOSTIC_PROCEDURE",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: false,
          dataType: "TEXT",
        },
      ],
      childFilters: [],
    },
    {
      category: "Medical Condition",
      table: "MEDICAL_CONDITION",
      fullTableName: "MEDICAL_CONDITION",
      friendlyName: "Medical Condition",
      key: "MEDICAL_CONDITION",
      column: "MEDICAL_CONDITION",
      operator: "=",
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "MEDICAL_CONDITION";
          },
          friendlyName: "Medical Condition",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType: "Document Search",
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "MEDICAL_CONDITION",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: false,
          dataType: "TEXT",
        },
      ],
      childFilters: [],
    },
    {
      category: "Body Measurement",
      table: "BODY_MEASUREMENT",
      fullTableName: "BODY_MEASUREMENT",
      friendlyName: "Body Measurement",
      key: "BODY_MEASUREMENT",
      column: "BODY_MEASUREMENT",
      operator: "=",
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "BODY_MEASUREMENT";
          },
          friendlyName: "Body Measurement",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType: "Document Search",
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "BODY_MEASUREMENT",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: false,
          dataType: "TEXT",
        },
      ],
      childFilters: [],
    },
    {
      category: "Sign Symptom",
      table: "SIGN_SYMPTOM",
      fullTableName: "SIGN_SYMPTOM",
      friendlyName: "Sign Symptom",
      key: "SIGN_SYMPTOM",
      column: "SIGN_SYMPTOM",
      operator: "=",
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "SIGN_SYMPTOM";
          },
          friendlyName: "Sign Symptom",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType: "Document Search",
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "SIGN_SYMPTOM",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: false,
          dataType: "TEXT",
        },
      ],
      childFilters: [],
    },
    {
      category: "Medical State",
      table: "MEDICAL_STATE",
      fullTableName: "MEDICAL_STATE",
      friendlyName: "Medical State",
      key: "MEDICAL_STATE",
      column: "MEDICAL_STATE",
      operator: "=",
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "MEDICAL_STATE";
          },
          friendlyName: "Medical State",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType: "Document Search",
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "MEDICAL_STATE",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: false,
          dataType: "TEXT",
        },
      ],
      childFilters: [],
    },
    {
      category: "Therapeutic Procedure",
      table: "THERAPEUTIC_PROCEDURE",
      fullTableName: "THERAPEUTIC_PROCEDURE",
      friendlyName: "Therapeutic Procedure",
      key: "THERAPEUTIC_PROCEDURE",
      column: "THERAPEUTIC_PROCEDURE",
      operator: "=",
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "THERAPEUTIC_PROCEDURE";
          },
          friendlyName: "Therapeutic Procedure",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType: "Document Search",
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "THERAPEUTIC_PROCEDURE",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: false,
          dataType: "TEXT",
        },
      ],
      childFilters: [],
    },
    {
      category: "Anatomical Structure",
      table: "ANATOMICAL_STRUCTURE",
      fullTableName: "ANATOMICAL_STRUCTURE",
      friendlyName: "Anatomical Structure",
      key: "ANATOMICAL_STRUCTURE",
      column: "ANATOMICAL_STRUCTURE",
      operator: "=",
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "ANATOMICAL_STRUCTURE";
          },
          friendlyName: "Anatomical Structure",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType: "Document Search",
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "ANATOMICAL_STRUCTURE",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: false,
          dataType: "TEXT",
        },
      ],
      childFilters: [],
    },
    {
      category: "Drug",
      table: "DRUG",
      fullTableName: "DRUG",
      friendlyName: "Drug",
      key: "DRUG",
      column: "DRUG",
      operator: "=",
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "DRUG";
          },
          friendlyName: "Drug",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType: "Document Search",
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "DRUG",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: false,
          dataType: "TEXT",
        },
      ],
      childFilters: [],
    },
    {
      category: "Drug Combo",
      table: "DRUG_COMBO",
      fullTableName: "DRUG_COMBO",
      friendlyName: "Drug Combo",
      key: "DRUG_COMBO",
      column: "DRUG_COMBO",
      operator: "=",
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "DRUG_COMBO";
          },
          friendlyName: "Drug Combo",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType: "Document Search",
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "DRUG_COMBO",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: false,
          dataType: "TEXT",
        },
      ],
      childFilters: [],
    },
    {
      category: "Medical Device",
      table: "MEDICAL_DEVICE",
      fullTableName: "MEDICAL_DEVICE",
      friendlyName: "Medical Device",
      key: "MEDICAL_DEVICE",
      column: "MEDICAL_DEVICE",
      operator: "=",
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "MEDICAL_DEVICE";
          },
          friendlyName: "Medical Device",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType: "Document Search",
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "MEDICAL_DEVICE",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: false,
          dataType: "TEXT",
        },
      ],
      childFilters: [],
    },
    {
      category: "Substance Abuse",
      table: "SUBSTANCE_ABUSE",
      fullTableName: "SUBSTANCE_ABUSE",
      friendlyName: "Substance Abuse",
      key: "SUBSTANCE_ABUSE",
      column: "SUBSTANCE_ABUSE",
      operator: "=",
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "SUBSTANCE_ABUSE";
          },
          friendlyName: "Substance Abuse",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType: "Document Search",
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "SUBSTANCE_ABUSE",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: false,
          dataType: "TEXT",
        },
      ],
      childFilters: [],
    },
    {
      category: "Laboratory Data",
      table: "LABORATORY_DATA",
      fullTableName: "LABORATORY_DATA",
      friendlyName: "Laboratory Data",
      key: "LABORATORY_DATA",
      column: "LABORATORY_DATA",
      operator: "=",
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "LABORATORY_DATA";
          },
          friendlyName: "Laboratory Data",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType: "Document Search",
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "LABORATORY_DATA",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: false,
          dataType: "TEXT",
        },
      ],
      childFilters: [],
    },
    {
      category: "Body Function",
      table: "BODY_FUNCTION",
      fullTableName: "BODY_FUNCTION",
      friendlyName: "Body Function",
      key: "BODY_FUNCTION",
      column: "BODY_FUNCTION",
      operator: "=",
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "BODY_FUNCTION";
          },
          friendlyName: "Body Function",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType: "Document Search",
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "BODY_FUNCTION",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: false,
          dataType: "TEXT",
        },
      ],
      childFilters: [],
    },
    {
      category: "Molecular Subtype",
      table: "MOLECULAR_SUBTYPE",
      fullTableName: "MOLECULAR_SUBTYPE",
      friendlyName: "Molecular Subtype",
      key: "MOLECULAR_SUBTYPE",
      column: "MOLECULAR_SUBTYPE",
      operator: "=",
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "MOLECULAR_SUBTYPE";
          },
          friendlyName: "Molecular Subtype",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType: "Document Search",
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "MOLECULAR_SUBTYPE",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: false,
          dataType: "TEXT",
        },
      ],
      childFilters: [],
    },
    {
      category: "Tumors, Nodes, Metastasis",
      table: "TNM",
      fullTableName: "TNM",
      friendlyName: "Tumors, Nodes, Metastasis",
      key: "TNM",
      column: "TNM",
      operator: "=",
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "TNM";
          },
          friendlyName: "Tumors, Nodes, Metastasis",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType: "Document Search",
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "TNM",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: false,
          dataType: "TEXT",
        },
      ],
      childFilters: [],
    },
    {
      category: "Tumors, Nodes, Metastasis",
      table: "TNM",
      fullTableName: "TNM",
      friendlyName: "Tumors, Nodes, Metastasis",
      key: "TNM",
      column: "TNM",
      operator: "=",
      queryBuilderJSON: [
        {
          id: "r-0.6445302420566821",
          field: (props) => {
            return "TNM";
          },
          friendlyName: "Tumors, Nodes, Metastasis",
          operators: operators.text,
          distinctValueJSON: (columnValue, phrase = null) => {
            return {
              dbType: "Document Search",
              autoComplete: phrase ? true : false,
              autoCompletePhrase: phrase,
              limit: globalLimit,
              name: "getDistinctColumnValues",
              columnNames: [
                {
                  columnName: "TNM",
                },
              ],
            };
          },
          showOperator: true,
          operator: "=",
          operatorLabel: "is",
          valueSource: "value",
          value: null,
          selectOptions: [],
          displayType: null,
          rowCount: 0,
          any: false,
          dataType: "TEXT",
        },
      ],
      childFilters: [],
    },
  ],
};

export default data;
